import axios from "axios";
import { Token } from "../utils/localStorage.util";
import config from "../config.js";

// IMPORTANTE: Esta tela usa a api-importacao-xml (rota /importadores). NUNCA api-financeiro.
// No browser: escolher API por origem para o mesmo build funcionar em app.taxationmind.com.br e em 192.168.1.4:3001.
const trimUrl = (u) => (typeof u === 'string' ? u.trim().replace(/\/+$/, '') : '');
const importacaoXml = trimUrl(config.REACT_APP_HOST_API_IMPORTACAO_XML);
const importacoes = trimUrl(config.REACT_APP_HOST_API_IMPORTACOES);
const financeiro = trimUrl(config.REACT_APP_HOST_API_FINANCEIRO);
const isFinanceiroUrl = (url) => !url ? false : url === financeiro || /api-financeiro/i.test(url);
const importacoesOk = importacoes && !isFinanceiroUrl(importacoes);
const envBaseURL = importacaoXml || (importacoesOk ? importacoes : '');

// Em prod (app.taxationmind.com.br): usa env se definido (URL real da API em prod), senão https://api-importacao-xml.taxationmind.com.br.
// Em dev (192.168.1.4:3001) usa :3346. Senão usa env.
const PROD_APP_API_URL = 'https://api-importacao-xml.taxationmind.com.br';
let baseURL = envBaseURL;
if (typeof window !== 'undefined' && window.location?.host) {
  const host = window.location.hostname;
  const origin = window.location.origin;
  if (/^app\.taxationmind\.com/i.test(host)) {
    baseURL = envBaseURL || PROD_APP_API_URL;
  } else if (/^192\.168\.1\.4$/.test(host) && /:3000$|:3001$/.test(origin)) {
    baseURL = 'http://192.168.1.4:3346';
  } else if (/:3000$|:3001$/.test(origin)) {
    baseURL = origin.replace(/:3000$|:3001$/, ':3346');
  }
  if (!baseURL) baseURL = envBaseURL;
}
if (!baseURL) {
  console.error('[api-importadores] Configure REACT_APP_HOST_API_IMPORTACAO_XML (api-importacao-xml). Esta tela não usa api-financeiro.');
}

const apiImportadores = axios.create({
  baseURL: baseURL || undefined,
});

apiImportadores.interceptors.request.use(
  async (config) => {
    const token = Token.getToken();
    if (token) {
      config.headers.Authorization = token;
    }

    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiImportadores.interceptors.response.use(
  (response) => {
    return response?.data !== undefined ? response.data : response;
  },
  async function (error) {
    if (error?.code === "ERR_NETWORK") {
      console.error('[api-importadores] Erro de rede - verifique se o servidor está rodando');
      console.error('[api-importadores] URL tentada:', error.config?.baseURL + error.config?.url);
      console.error('[api-importadores] baseURL configurada:', baseURL);
      return Promise.reject(new Error('Erro de conexão. Verifique se o servidor está rodando.'));
    }
    return Promise.reject(error);
  }
);

/**
 * Busca todas as importações com filtros opcionais
 */
export function buscarImportacoes(params = {}) {
  const queryParams = new URLSearchParams();
  
  if (params.tipo) queryParams.append("tipo", params.tipo);
  if (params.cnpj) queryParams.append("cnpj", params.cnpj);
  if (params.dataInicio) queryParams.append("dataInicio", params.dataInicio);
  if (params.dataFim) queryParams.append("dataFim", params.dataFim);
  if (params.status) queryParams.append("status", params.status);
  if (params.arquivo) queryParams.append("arquivo", params.arquivo);
  if (params.buscaRapida) queryParams.append("buscaRapida", params.buscaRapida);
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);
  if (params.sortBy) queryParams.append("sortBy", params.sortBy);
  if (params.sortOrder) queryParams.append("sortOrder", params.sortOrder);

  const queryString = queryParams.toString();
  const url = `/importadores${queryString ? `?${queryString}` : ''}`;
  
  return apiImportadores.get(url);
}

/**
 * Busca logs de uma importação específica
 */
export function buscarLogsImportacao(importacaoId) {
  return apiImportadores.get(`/importadores/${importacaoId}/logs`);
}

/**
 * Busca estatísticas (counts) de importações com filtros
 */
export function buscarEstatisticas(params = {}) {
  const queryParams = new URLSearchParams();
  
  if (params.tipo) queryParams.append("tipo", params.tipo);
  if (params.cnpj) queryParams.append("cnpj", params.cnpj);
  if (params.dataInicio) queryParams.append("dataInicio", params.dataInicio);
  if (params.dataFim) queryParams.append("dataFim", params.dataFim);
  if (params.status) queryParams.append("status", params.status);
  if (params.arquivo) queryParams.append("arquivo", params.arquivo);
  if (params.buscaRapida) queryParams.append("buscaRapida", params.buscaRapida);

  const queryString = queryParams.toString();
  const url = `/importadores/estatisticas${queryString ? `?${queryString}` : ''}`;
  
  return apiImportadores.get(url);
}

/**
 * Busca tipos de importação disponíveis na base
 */
export function buscarTipos() {
  return apiImportadores.get('/importadores/tipos');
}

export default apiImportadores;
